import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Widget } from '@typeform/embed-react';
import PlaceHolder from '../../portal/common/PlaceHolder';
const TypeformWidget = ({ formID, formHeight, limitToPageWidth, editData, }) => {
    if (!(formID && formID.length) && editData) {
        return (_jsx(Box, { sx: {
                ...(limitToPageWidth && {
                    width: '100%',
                    maxWidth: 1200,
                    marginX: 'auto',
                }),
                height: `${formHeight}px`,
            }, children: _jsx(PlaceHolder, { placeHolderName: "Configure Typeform Widget" }) }));
    }
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
                height: `${formHeight}px`,
            }),
        }, children: _jsx(Widget, { id: formID, className: "TypeformForm", inlineOnMobile: true, height: formHeight, style: {
                height: `${formHeight}px`,
            } }) }));
};
TypeformWidget.meta = {
    group: 'design',
    name: 'Typeform Widget',
    sort: 80,
    description: 'Embed a Typeform Form',
    props: [
        {
            key: 'formID',
            name: 'Typeform Form ID',
            type: 'text',
            description: 'The Typeform Form ID.',
        },
        {
            key: 'formHeight',
            name: 'Form Height',
            type: 'number',
            description: 'Height (in px) of survey form widget',
            min: 50,
            max: 1000,
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'TypeformWidget',
        props: {
            limitToPageWidth: true,
            formHeight: 500,
        },
    },
};
export default TypeformWidget;
//# sourceMappingURL=TypeformWidget.js.map